import { z } from "zod";

export const imageryFileSchema = z.object({
	filename: z.string(),
	date: z.coerce.date(),
});

export const imagerySchema = z.object({
	files: z.array(imageryFileSchema),
});

export type imageFilesType = z.infer<typeof imageryFileSchema>;
export type imageryType = z.infer<typeof imagerySchema>;
